import React from 'react';

const HHTTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "Contratamos una posición gerencial clave y el proceso fue tan eficiente que decidimos centralizar todo nuestro reclutamiento con ellos.",
      author: "Laura Hernández",
      position: "Directora de Talento Humano, Grupo Sigma"
    },
    {
      id: 2,
      quote: "El seguimiento postventa fue algo que nunca habíamos experimentado. Nos sentimos realmente acompañados durante la integración del candidato.",
      author: "Roberto Mena",
      position: "CEO, Inversora Axia"
    },
    {
      id: 3,
      quote: "Lograron encontrar al perfil ideal para una vacante muy especializada en menos de dos semanas.",
      author: "Silvia Duarte",
      position: "Líder de RH, BioSolutions LATAM"
    },
    {
      id: 4,
      quote: "Gracias al análisis psicométrico y al estudio sociocriminológico, tuvimos la tranquilidad de contratar con datos y no solo con intuición.",
      author: "Mauricio León",
      position: "Coordinador de Seguridad Corporativa, VectorCorp"
    },
    {
      id: 5,
      quote: "Nos ayudaron a profesionalizar nuestro proceso de selección. Hoy tenemos perfiles más alineados con nuestros valores.",
      author: "Andrea Solís",
      position: "Gerente de Cultura Organizacional, ALFA Consultores"
    },
    {
      id: 6,
      quote: "El equipo de Hiring Human Talent fue empático, eficiente y estratégico. Lo recomiendo ampliamente para posiciones directivas.",
      author: "Carlos Vázquez",
      position: "COO, SmartLogistics"
    }
  ];

  return (
    <section className="py-20 bg-purple-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-purple-900">Testimonios de Clientes Satisfechos</h2>
          <p className="text-gray-600 mt-4">Lo que dicen las empresas que han confiado en nuestro servicio</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-purple-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-purple-900">{testimonial.author}</h4>
                  <p className="text-sm text-gray-600">{testimonial.position}</p>
                </div>
              </div>
              <blockquote className="text-gray-700 italic relative">
                <svg className="w-6 h-6 text-purple-200 absolute -top-2 -left-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
                {testimonial.quote}
              </blockquote>
            </div>
          ))}
        </div>

        {/* Testimonios adicionales en un segundo bloque */}
        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-6">
              <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-purple-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <h4 className="font-semibold text-purple-900">Natalia Pérez</h4>
                <p className="text-sm text-gray-600">Reclutadora Sr., Industrias Reser</p>
              </div>
            </div>
            <blockquote className="text-gray-700 italic relative">
              <svg className="w-6 h-6 text-purple-200 absolute -top-2 -left-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
              "Antes batallábamos meses para cubrir vacantes técnicas. Ahora, en 15 días tenemos finalistas listos para entrevista."
            </blockquote>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-6">
              <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-purple-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <h4 className="font-semibold text-purple-900">Julio Álvarez</h4>
                <p className="text-sm text-gray-600">Gerente General, TalentCloud México</p>
              </div>
            </div>
            <blockquote className="text-gray-700 italic relative">
              <svg className="w-6 h-6 text-purple-200 absolute -top-2 -left-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
              "Los resultados hablan por sí solos: contratamos 6 perfiles en un trimestre y todos siguen en la empresa."
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HHTTestimonials;